<template>
  <el-row class="ta-header">
    <div class="ta-chart-header">
      {{$t('charts.frequency.rotorDynamicTitle')}}
    </div>
    <div :id="id"/>
  </el-row>
</template>

<script>
import FrequencyChartMixin from './ChartMixin'

export default {
  name: 'FrequencyDynamicStress',
  mixins: [FrequencyChartMixin],
  methods: {
    dataMap (f) {
      return f.dynamicStressOnRotorFrequency
    }
  }
}
</script>

<style scoped>

</style>
